import { Component, inject, input, model, output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TSocialContent } from '@interfaces/campaign-analytics-api.interface';
import { TranslateModule } from '@ngx-translate/core';
import { IChannel } from '@pages/creators/creators.interface';
import { ProfileDateFilterComponent } from '@shared/components/profile-date-filter/profile-date-filter.component';
import {
  EDateRangeType,
  IProfileDateFilterState,
} from '@shared/components/profile-date-filter/profile-date-filter.interface';
import { CreatorDetailsFilterService } from '../creator-details-filter.service';
import { ICreatorDetailsFilter } from '../creator-details.interface';
import { CreatorChannelsFilterComponent } from './creator-channels-filter/creator-channels-filter.component';

@Component({
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    TranslateModule,
    CreatorChannelsFilterComponent,
    ProfileDateFilterComponent,
  ],
  selector: 'app-creator-details-filters',
  templateUrl: './creator-details-filters.component.html',
})
export class CreatorDetailsFiltersComponent {
  public readonly channels = input.required<IChannel[] | null>();
  public readonly socialContents = input.required<TSocialContent[] | null>();
  public readonly socialContentsOriginal = input.required<TSocialContent[] | null>();
  public readonly creatorDetailsFilter = model.required<ICreatorDetailsFilter>();
  public readonly dateFilterState = input<IProfileDateFilterState | null>(null);

  public readonly loading = input<boolean>(false);

  public readonly socialContentsChanged = output<TSocialContent[]>();

  public readonly creatorDetailsFilterChanged = output<ICreatorDetailsFilter>();
  public readonly dateRangeChanged = output<Pick<ICreatorDetailsFilter, 'endDate' | 'startDate'>>();
  public readonly selectedRangeChanged = output<EDateRangeType>();

  private readonly creatorDetailsFilterService = inject(CreatorDetailsFilterService);

  public onChannelsChanged(channels: Set<string>): void {
    this.creatorDetailsFilter.set({
      ...this.creatorDetailsFilter(),
      channelTechnicalIds: new Set(channels),
    });

    this.socialContentsChanged.emit(
      this.creatorDetailsFilterService.filterSocialContents(
        this.socialContentsOriginal() ?? [],
        this.creatorDetailsFilter(),
      ),
    );
    this.creatorDetailsFilterChanged.emit(this.creatorDetailsFilter());
  }

  public onDateRangeChanged(dateRange: Pick<ICreatorDetailsFilter, 'endDate' | 'startDate'>): void {
    this.creatorDetailsFilter.set({
      ...this.creatorDetailsFilter(),
      endDate: dateRange.endDate,
      startDate: dateRange.startDate,
    });

    this.dateRangeChanged.emit(dateRange);
    this.creatorDetailsFilterChanged.emit(this.creatorDetailsFilter());
  }

  public onSelectedRangeChanged(selectedRange: EDateRangeType): void {
    this.selectedRangeChanged.emit(selectedRange);
  }
}
